import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import OfflineBlindDataOrderEdit from '../edit/index';
import OfflineBlindDataOrderAdd from '../edit/add';
import BlindDataOrderActivity from '../edit/activity';
export default {
  name: 'OfflineBlindDataOrderList',
  components: {
    OfflineBlindDataOrderEdit: OfflineBlindDataOrderEdit,
    OfflineBlindDataOrderAdd: OfflineBlindDataOrderAdd,
    BlindDataOrderActivity: BlindDataOrderActivity
  },
  data: function data() {
    return {
      activeName: 'first',
      type: 1,
      isSelect: this.checkauthority('of_blind_data_order_select'),
      isCreate: this.checkauthority('agency_blind_data_order_give'),
      isExport: this.checkauthority('agency_blind_data_order_export'),
      isDj: this.checkauthority('agency_blind_data_order_regster'),
      isUpdate: this.checkauthority('blind_data_order_update'),
      isDelete: this.checkauthority('blind_data_order_delete'),
      isOrderInfo: this.checkauthority('agency_blind_data_order_user_info_select'),
      selectForm: {
        createTime: null,
        createTimes: [],
        selectCitys: [],
        memberNo: null
      },
      citys: [],
      editDisabled: false,
      dialogVisible: false,
      addDisabled: false,
      adddialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      if (this.activeName === 'first') {
        this.initTableData();
      } else {
        this.$refs.blindDataOrderActivity.initData();
      }
    },
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    exportExcel: function exportExcel() {
      this.$message.success('业务完善在做');
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.enumList = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this3 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.daleteApi(index, data);
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                blindDataOrderId: data.blindDataOrderId
              };
              _context3.n = 1;
              return api.DELETE_BLINDDATAORDER(par);
            case 1:
              _this4.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.DELETE_BATCH_BLINDDATAORDER(par);
            case 1:
              _this5.$message.success('操作成功');
              _this5.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this6 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this6.tableSelects.forEach(function (element) {
          par.push(element.blindDataOrderId);
        });
        _this6.deleteBatchApi(par);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    toDj: function toDj(index, data) {
      this.$refs.add.setTitle('活动登记');
      this.addDisabled = false;
      this.adddialogVisible = true;
      this.$refs.add.initData(data);
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    userAddClose: function userAddClose() {
      this.adddialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTime = null;
      this.selectForm.createTimes = [];
      this.selectForm.memberNo = null;
      this.selectForm.selectCitys = [];
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                type: _this7.type,
                pageNo: _this7.pageNo,
                pageSize: _this7.pageSize,
                memberNo: _this7.selectForm.memberNo,
                cityStr: _this7.selectForm.selectCitys
              };
              if (_this7.selectForm.createTimes.length >= 2) {
                par.startCreateTime = _this7.selectForm.createTimes[0];
                par.endCreateTime = _this7.selectForm.createTimes[1];
              }
              _context5.n = 1;
              return api.GET_BLINDDATAORDER_PAGE_LIST(par);
            case 1:
              res = _context5.v;
              _this7.tableData = res.body.datas;
              _this7.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
    this.initCitys();
  }
};